<template>
  <v-app>
    <v-app-bar dense app scroll-threshold="0">
      <AppbarAccount></AppbarAccount>
    </v-app-bar>
    <main class="v-main">
      <router-view></router-view>
    </main>
  </v-app>
</template>

<script>
import AppbarAccount from "./components/AppbarAccount";
export default {
  name: "App",
  components: {
    AppbarAccount,
  },
  data: () => ({
    //
  }),
};
</script>

<style>
.v-main {
  padding-top: 80px !important;
  padding-bottom: 80px !important;
}
</style>
